import React from 'react';
import FormOrderBy from './FormOrderBy';
import ContentProduct from './ContentProducts';
import _ from 'lodash';
class Content extends React.Component {
    
    addToCart = (product)=>{
        let {cart} = this.props,
        idx = -1;
        if(cart && cart.length)
        {
            idx = cart.findIndex((item)=>parseInt(item.id) === parseInt(product.id));
            idx > -1 && 
                (cart[idx].cnt += 1);
        }
        (!cart.length || idx === -1) && cart.push({id:product.id,pcd:product.pcd,title:product.title,
        price: product.meta.price_after_discount,
        price_origin:parseFloat(product.meta.price),
        category:product.meta.category,
        image: product.image,
        link:product.link,cnt:1});
        this.props.addToCart(cart);
    }
    handleOnChange = (inputFilter)=>{
        _.remove(inputFilter,(item)=>Object.keys(item)[0]==='page');
        this.props.handleOnChangeFilter(inputFilter);
    }
    handleClickLink = (page)=>{
        let {inputFilter} = this.props;
        let index = inputFilter.findIndex((item)=>Object.keys(item)[0]==='page');
        index === -1 ? inputFilter.push({page:page}):inputFilter[index]['page'] = page;
        this.props.handleOnChangeFilter(inputFilter);
    }
    handleChangeKeyword=(value)=>{
        this.props.handleChangeKeyword(value);
    }

    handleResetFilterSearch=()=>{
        this.props.handleResetFilterSearch();
    }

    render(){
        let {inputFilter, products, author, searchValues} = this.props;
        return (
            <div className="container bg-white">
                <div className="row bg-light">
                    {author && author.banner ? 
                    <div className="banner mb-4">
                        <a href={author.url}><img src={author.banner} className="img-fluid" alt="Omega" /></a>
                    </div>
                    :null}
                    <div className="container">
                        <div className="row">
                            <div className="col-12">
                                <div className="row bg-white p-3">
                                    <div className="form-order-page">
                                        <FormOrderBy handleResetFilterSearch={this.handleResetFilterSearch} 
                                        searchValues={searchValues} handleOnChange={this.handleOnChange} 
                                        inputFilter={inputFilter}
                                        handleChangeKeyword={this.handleChangeKeyword}/>
                                    </div>
                                    <div className="product-list w-100">
                                        <ContentProduct addToCart={this.addToCart} handleClickLink={this.handleClickLink} 
                                        products={products} />
                                    </div>
                                </div>
                            </div>
                            {/* end product */}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default Content;